export default [["-", "'"]]
